import React, { useEffect, useRef, useState } from 'react';
import './whatsappForm/Carousel.css';
import { faBold, faCode, faInfoCircle, faItalic, faSmile, faStrikethrough, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Axios from 'axios';
import { HOST_URL, WhstappGalleryList } from '../api/Api';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { userId, userToken } from '../../Utils/userAuth';
import { WHATSAPP_TEMPLATE_LIST } from '../../../constants/ServiceConstants';
import { userloginDetails } from '../../Utils/AdminAuth';

const Carousel = (props) => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    let previewData = props.previewData
    const fileInputRef = useRef(null);
    const finalRetrieveData = props.previewData.ReceiveFinalData
    const urlData = previewData.showCarouselUrl
    const { id } = useParams();
    const { sendData, button, cradLength, moveCard,
        moveWindow, sendCardContent, sendFile, sendIndex,
        onForwardFunctionSend, onBackwardFunctionSend, SendfinalData,
        sendMedia, mediaidData, sendImage, showUrl,
        sendCardsData, sendContentData, sendHandlerData, brandNumber, sendErrorMessage } = props;
    const [cards, setCards] = useState([1]);
    const [selectedCard, setSelectedCard] = useState(1);
    const [selectedIndex, setSelectedIndex] = useState(1);
    const [cardContent, setCardContent] = useState({ 1: '' });
    const [enableButton, setEnableButton] = useState(false);
    const [moveCards, setMoveCards] = useState('');
    const [move, setMove] = useState(1);
    const [image, setImage] = useState(null);
    const [WhatsappPreview, setWhatsappPreview] = useState(false);
    const [headerImage, setHeaderImage] = useState({}); // To manage header images
    const [majorData, setMajorData] = useState({})
    const [receiveData, setReceiveData] = useState({})
    const [fileType, setFileType] = useState('')
    const [file, setFile] = useState(null);
    const [mediaId, setMediaID] = useState('');
    const [arrayId, setArrayId] = useState([]);
    const [headerHandler, setHeaderHandler] = useState({ 1: '' });
    const [imageSrc, setImageSrc] = useState({});
    const [displayUrl, setDispalyUrl] = useState([])
    

    const onMessageChange = (e) => {
        const newContent = e.target.value;
        setCardContent(prevContent => ({
            ...prevContent,
            [selectedCard]: newContent
        }));
        sendContentData({ ...cardContent, [selectedCard]: newContent })
    };
    const [media, setMedia] = useState({ 1: '' });
    const [medialist, setMediaList] = useState();
    const [imageURL, setImageURL] = useState();

    const history = useHistory();

    useEffect(() => {
        let paramData = {
            user_id: userId,
            method: "retrieve",
            token: userToken
        }
        WhstappGalleryList(paramData).then((res) => {
            // console.log("res.data.data", res.data.data);
            setMediaList(res.data.data);
        });
        let data = []
        let finalData = null
        if (!id) {
            return
        }
        if (finalRetrieveData.length === 0) {
            return
        }
        for (let i = 0; i < finalRetrieveData?.length; i++) {
            data.push(i + 1)
        }

        setCards(data)
        let urlDisplayData = urlData.reduce((acc, url, i) => {
            acc[i + 1] = url;
            return acc;
        }, {});

        //   finalRetrieveData.filter((x) => {
        //     console.log("data" , x)
        //   })

        setImageSrc(urlDisplayData)
    }, [finalRetrieveData]);

    useEffect(() => {
        if (!Array.isArray(finalRetrieveData) || finalRetrieveData.length === 0) {
            return;
        }

        const mappedData = finalRetrieveData.reduce((acc, item, index) => {
            // Find the component with type "BODY"
            const bodyComponent = item.components.find(c => c.type === "BODY");
            if (bodyComponent && bodyComponent.text) {
                acc[index + 1] = bodyComponent.text;
            }
            return acc;
        }, {});

        // console.log(mappedData);
        setCardContent(mappedData)
        // mappedData will be { 1: "test 1", 2: "test 2" }
    }, [finalRetrieveData]);


    // const CreateSession = async () => {
    //     const myHeaders = new Headers();
    //     myHeaders.append("apikey", "daeec986-6368-11ef-b1d4-02c8a5e042bd");

    //     const requestOptions = {
    //         method: "POST",
    //         headers: myHeaders,
    //         redirect: "follow"
    //     };

    //     let response = await Axios.get(`https://partnersv1.pinbot.ai/v3/app/uploads`, {
    //         headers: {
    //             'apikey': "daeec986-6368-11ef-b1d4-02c8a5e042bd"  // Add other headers if needed
    //         }
    //     })

    //     console.log(response)

    // };

    // console.log(cardContent)




    // console.log(props.finalData)

    useEffect(() => {
        setReceiveData(props.finalData)
    }, [props.finalData])

    // useEffect(()=>{
    //     setCards(prevContent => ({
    //         ...prevContent,
    //          receiveData
    //       }));
    // },[receiveData])

    // console.log(receiveData)
    // console.log(cards)

    const changeImage = (e) => {
        const file = e.target.files;
        if (file) {
            const newImageURL = URL.createObjectURL(file[0]);
            setImageURL(newImageURL);
            setMedia(prevImages => ({
                ...prevImages,
                [selectedCard]: newImageURL
            }));
        }
    };

    // const handleUpload = () => {
    //     const file = image[selectedCard];
    //     if (file) {
    //         sendFile(file.name);
    //     }
    // };

    const addCard = () => {
        if (cards.length < 10) {
            const newCardId = cards.length + 1;
            setCards([...cards, newCardId]);
            sendCardsData([...cards, newCardId])
            setCardContent(prevContent => ({ ...prevContent, [newCardId]: '' }));
            sendContentData({ ...cardContent, [newCardId]: '' })
        }
    };

    const HandleButton = () => {
        setEnableButton(cards.length > 1);
    };

    const DeleteCards = () => {
        if (cards.length > 0) {
            const updatedCards = cards.slice(0, -1);
            setCards(updatedCards);
            sendCardsData(updatedCards)

            if (updatedCards.length > 0) {
                setSelectedCard(updatedCards[0]);
            } else {
                setSelectedCard(null);
            }

        }
    };


    const Action = (card, index) => {
        setSelectedCard(card);
        setSelectedIndex(index);
    };

    const moveCardForward = () => {
        setSelectedCard(selectedCard + 1);
        setSelectedIndex(selectedIndex + 1);
    }

    const moveCardBackward = () => {
        setSelectedCard(selectedCard - 1);
        setSelectedIndex(selectedIndex - 1);
    }



    // console.log(JSON.stringify(majorData))
    useEffect(() => {
        const SendDataToparent = () => {
            sendData(selectedCard);
            sendIndex(selectedIndex);
            button(enableButton);
            cradLength(cards);
            moveWindow(moveCards);
            setMove(props.move);
            sendCardContent(cardContent);
            sendMedia(media);
            mediaidData(arrayId);
            sendImage(imageSrc);
        };
        SendDataToparent();
        HandleButton();
        setMoveCards(selectedCard);
    }, [selectedCard, sendData, enableButton, button, cards, cradLength, selectedCard, moveCard, moveCards, moveWindow, cardContent, sendCardContent, sendIndex, selectedIndex, majorData, sendMedia, media, mediaidData, arrayId, sendImage, imageSrc]);

    const Redirect = () => {
        history.push('/dashboard/whatsapp-gallery')
    }

    const onImageChange = (e) => {
        const selectedValue = e.target.value;
        // Set the selected media URL to state
        setMedia(prevMedia => ({
            ...prevMedia,
            [selectedCard]: selectedValue
        }));
    };

    const onUrlChange = (e) => {
        setImageURL(e.target.value);
    }

    // console.log(media)

    const setImageinText = () => {
        // Assuming `media` is what you want to set for the card
        setMedia(prevMedia => ({
            ...prevMedia,
            [selectedCard]: imageURL
        }));
    };

    // console.log(medialist)

    // console.log(media);
    // console.log(imageURL)

    // const SendImage = async () => {
    //     let data = {
    //         token: userToken,
    //         user_id: userId,
    //         method: "upload_image_meta",
    //         image_url: media
    //     }
    //     console.log(data)
    //     let response = await fetch("https://console.authkey.io/api/whatsapp_template.php", {
    //         method: "post",
    //         headers: {
    //             "content-Type": "application/json",
    //         },
    //         body: JSON.stringify(data),
    //     });
    //     let result = await response.json()
    //     if (result) {
    //         console.log(result)
    //         generateJSONData(result.message);
    //     }
    // }

    // console.log(props.previewData);

    const handleFileChange = async (event) => {
        const selectedFile = event.target.files[0];
        if (!selectedFile) return;

        const parts = selectedFile?.name?.split(".");
        const filename = parts.slice(0, -1).join(".");
        const filetypemedia = parts[parts.length - 1]?.toLowerCase();

        const fileSizeMB = selectedFile.size / (1024 * 1024);

        const allowedImageTypes = ["image/jpeg", "image/png"];
        const allowedVideoTypes = ["video/mp4", "video/3gp"];

        const isImage = allowedImageTypes.includes(selectedFile.type);
        const isVideo = allowedVideoTypes.includes(selectedFile.type);

        const resetInput = () => {
            if (fileInputRef.current) fileInputRef.current.value = "";
        };

        // ✅ TYPE VALIDATION
        if (!isImage && !isVideo) {
            alert("Only JPG, JPEG, PNG images or MP4/3GP videos are allowed.");
            resetInput();
            return;
        }

        // ✅ SIZE VALIDATION
        if (isImage && fileSizeMB > 5) {
            alert("Image size must be ≤ 5 MB.");
            resetInput();
            return;
        }

        if (isVideo && fileSizeMB > 10) {
            alert("Video size must be ≤ 10 MB.");
            resetInput();
            return;
        }

        if (selectedFile) {
            const reader = new FileReader();

            reader.onloadend = async () => {

                // 🔥 ORIGINAL LOGIC
                const processFile = async () => {
                    setImageSrc(prevContent => ({
                        ...prevContent,
                        [selectedCard]: reader.result
                    }));

                    if (selectedFile.type.startsWith('image/') || selectedFile.type.startsWith('video/')) {

                        setFile(prevContent => ({
                            ...prevContent,
                            [selectedCard]: selectedFile
                        }));

                        let formData1 = new FormData();
                        formData1.append('amdfile', selectedFile);
                        formData1.append('method', 'upload');
                        formData1.append('user_id', previewData.userID);
                        formData1.append('token', previewData.token);
                        formData1.append('brand_number', brandNumber)

                        let formData2 = new FormData();
                        formData2.append('file', selectedFile);
                        formData2.append('method', 'upload');
                        formData2.append('user_id', previewData.userID);
                        formData2.append('token', previewData.token);
                        formData2.append('brand_number', brandNumber)

                        let formData3 = new FormData();
                        formData3.append("amdfile", selectedFile);
                        formData3.append("doc_name", filename);
                        formData3.append("doc_type", filetypemedia);
                        formData3.append("user_id", previewData.userID);
                        formData3.append("token", previewData.token);
                        formData3.append("method", "create");
                        formData3.append('brand_number', brandNumber)

                        try {
                            const [response1, response2, response3] = await Promise.all([
                                fetch(`${HOST_URL}/get_facebook_handleid.php`, { method: "POST", body: formData1 }),
                                fetch(`${HOST_URL}/get_facebook_mediaid.php`, { method: "POST", body: formData2 }),
                                fetch(`${HOST_URL}/uploadFileWhatsapp.php`, { method: "POST", body: formData3 })
                            ]);

                            const result1 = await response1.json();
                            if (result1.success) {
                                setHeaderHandler(prevContent => ({
                                    ...prevContent,
                                    [selectedCard]: result1.header_handle
                                }));

                                sendHandlerData({ ...headerHandler, [selectedCard]: result1.header_handle })

                            } else {
                                sendErrorMessage(result1.message || "Failed to upload header image. Please try again.");
                            }

                            const result2 = await response2.json();
                            if (result2.success) {
                                setMediaID(result2.media_id);
                                if (result2.media_id !== null) {
                                    setArrayId(prevArray => [...prevArray, result2.media_id]);
                                }
                            } else {
                                sendErrorMessage(result2.message || "Failed to upload media. Please try again.");
                            }

                            const result3 = await response3.json();
                            if (result3.success) {
                                setDispalyUrl((prevState) => [...prevState, result3.url])
                                showUrl(result3.url)
                            } else {
                                sendErrorMessage(result3.message || "Failed to upload file. Please try again.");
                            }

                        } catch (error) {
                            console.log("Error during API calls:", error);
                            sendErrorMessage("Something went wrong while uploading the file. Please try again.");
                        }
                    } else {
                        alert('Please select a valid image file');
                    }
                };

                // ✅ IMAGE DIMENSION + RATIO VALIDATION
                if (isImage) {
                    const img = new Image();
                    img.src = reader.result;

                    img.onload = () => {
                        const width = img.width;
                        const height = img.height;

                        if (width < 500 || height < 500) {
                            alert("Image must be at least 500x500 px.");
                            resetInput();
                            return;
                        }

                        const ratio = width / height;
                        if (ratio < 1 || ratio > 16 / 9) {
                            alert("Aspect ratio should be between 1:1 and 16:9 means 1920 X 1080.");
                            resetInput();
                            return;
                        }

                        processFile();
                    };
                } else {
                    // video — no dimension check needed
                    processFile();
                }
            };

            reader.readAsDataURL(selectedFile);
        }
    };
    


    return (
        <>
            <div className='corousal-card'>
                <div className='details-section'>
                    <div style={{ fontWeight: "bold" }}>Carousel Card</div>
                    <p style={{ fontSize: "12px" }}>You can set priority by dragging and dropping cards from left to right</p>
                    <p style={{ fontSize: "12px" }}><b>Body text (Description) Short supporting text ❌ No (single-line only) ~160 characters</b></p>
                    {cards.length < 10 && (
                        <li className='add-list' style={{ fontSize: "12px", cursor: "pointer" }} onClick={addCard}>
                            + Add Card
                        </li>
                    )}
                    <div className='section-body-wrap'>
                        <div className='corousal-card-pagination-bar-container'>
                            <ul className='whatsappCardList' id='item'>
                                {cards.map((card, i) => {
                                    let index = i + 1;
                                    return (
                                        <li
                                            key={card}
                                            className={index === selectedCard ? 'active-dropzone' : 'choose-list'}
                                            onClick={() => Action(card, index)}
                                        >
                                            Card {card}
                                        </li>
                                    )
                                })}
                            </ul>

                        </div>
                        <div className='row'>
                            {/* <div className='col-9'>
                            <div className="d-flex flex-row mb-3 whatsappInputFile">
                                <input
                                    type="file"
                                    className="form-control whatsappFormFIle"
                                    name="imagefile"
                                    accept="image/*"
                                    onChange={changeImage}
                                />
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={CreateSession}
                                    style={{ height: "10vh", width: "30vh" }}
                                >
                                    Upload
                                </button>
                            </div>
                        </div> */}
                            {/* <div className='col-10 mt-2'>
                                <div className="bg-dark">
                                    <div className="input-group mb-2 mr-sm-2">
                                        <div className="input-group-text">
                                            Image URL
                                        </div>
                                        <input
                                            className="form-control"
                                            type="text"
                                            value={media[selectedCard] || ''}
                                            onChange={onImageChange}
                                        />
                                    </div>
                                </div>
                            </div> */}
                            <div className='col-2'>
                                {cards.length > 1 && (
                                    <FontAwesomeIcon onClick={DeleteCards} icon={faTrashAlt} />
                                )}
                            </div>
                        </div>
                        {/* <div className='row mb-3'>
                            <div className='col-8'>
                                <span
                                    data-toggle="modal"
                                    data-target="#galleryPopup"
                                    className="badge badge-info"
                                >
                                    Choose From Media Gallery
                                </span>                               
                            </div>
                            <div className='col-4'>
                                {media ? (
                                        Object.keys(media).map((x, i) => {
                                            // console.log(media[x])
                                            let index = i + 1
                                            return (
                                                <div key={index}>
                                                    {index === selectedCard ? <a target="_blank" href={media[x]} rel="noopener noreferrer">
                                                        <span className="badge badge-success">Preview</span>
                                                    </a> : null}
                                                </div>
                                            )
                                        })
                                    ) :
                                        null
                                    }
                                </div>
                        </div> */}

                        <div className="input-group mb-2 mt-4 mr-sm-2">
                            <div className="input-group-prepend">
                                <div className="input-group-text">Image Upload</div>
                            </div>
                            <input
                                type="file"
                                name="file"
                                ref={fileInputRef}
                                accept="image/,video/"
                                onChange={handleFileChange}
                                className="form-control"
                                disabled={!!id}
                            />

                            {/* Summary / Guidelines */}
                            <small className="text-muted d-block mt-2" style={{fontSize:"12px"}}>
                                <b>Note : Supported formats: JPG, JPEG, PNG (max 5 MB). Recommended size: 1080×1080 px (square) or 1125×600 px (landscape).
                                Aspect ratio: 1:1 to 16:9. Use consistent image sizes across all cards (max 10) and avoid portrait images to prevent cropping.</b>
                            </small>

                            {/* <div className="input-group-prepend">
                                <div className="input-group-text">Image Upload</div>
                                <button type="button" onClick={"SubmitFile"} className="input-group-text btn btn-info">Upload</button>
                            </div> */}
                        </div>

                        <div className="whatsapp-box">
                            <div className="mb-3">
                                <label>
                                    <h4>
                                        Card Body
                                        <span className="text-danger">*</span>
                                    </h4>
                                </label>

                                <textarea
                                    id="message-body"
                                    onChange={onMessageChange}
                                    rows={5}
                                    value={cardContent[selectedCard] || ''}
                                    placeholder='Enter Text Here'
                                    className="form-control mb-1"
                                ></textarea>

                            </div>
                        </div>
                        {/* <div className="d-flex justify-content-between">
                                    <div className="d-flex">
                                        <div className="mx-1 px-1 cursor-pointer">
                                            <FontAwesomeIcon icon={faSmile} />
                                        </div>
                                        <div className="mx-1 px-1 cursor-pointer">
                                            <FontAwesomeIcon icon={faBold} />
                                        </div>
                                        <div className="mx-1 px-1 cursor-pointer">
                                            <FontAwesomeIcon icon={faItalic} />
                                        </div>
                                        <div className="mx-1 px-1 cursor-pointer">
                                            <FontAwesomeIcon icon={faStrikethrough} />
                                        </div>
                                        <div className="mx-1 px-1 cursor-pointer">
                                            <FontAwesomeIcon icon={faCode} />
                                        </div>
                                    </div>
                                    <div>
                                        <span><FontAwesomeIcon icon={faInfoCircle} /></span>
                                    </div>
                                </div> */}


                        <div className="d-flex justify-content-between mt-3">
                            {/* <button
                                className="btn btn-sm btn-secondary"
                                onClick={generateJSONData}
                            // disabled={cards.indexOf(selectedCard) === cards.length - 1}
                            >
                                Create JSON
                            </button> */}
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="modal fade"
                id="galleryPopup"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="galleryPopupLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="galleryPopupLabel">
                                Choose Media
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {medialist && (
                                <div className="input-group drop-down-icons">
                                    <select
                                        onChange={onUrlChange}
                                        className="form-control"
                                        value={imageURL}
                                    >
                                        <option value="">Select Media</option>
                                        {medialist.map((item) => (
                                            <option value={item.doc_url}>{item.doc_name}</option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            <a className="mt-3 d-block" target="_blank" href={imageURL}>
                                <span className="badge badge-success">Preview</span>
                            </a>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                data-dismiss="modal"
                                className="btn btn-warning"
                                onClick={Redirect}
                            >
                                Upload
                            </button>
                            <button
                                type="button"
                                data-dismiss="modal"
                                className="btn btn-primary"
                                onClick={setImageinText}
                            >
                                Select
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Carousel;
